import { render, staticRenderFns } from "./ScRecommendResultView.vue?vue&type=template&id=2eba322e&scoped=true&"
import script from "./ScRecommendResultView.vue?vue&type=script&lang=js&"
export * from "./ScRecommendResultView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba322e",
  null
  
)

export default component.exports